// Global JavaScript for DIKE theme

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function() {
  // Handle mobile menu drawer
  const menuDrawerContainer = document.getElementById('Details-menu-drawer-container');
  const menuDrawer = document.getElementById('menu-drawer');
  const menuDrawerMenu = document.getElementById('menu-drawer-menu');
  
  // Debug: verify elements exist
  if (!menuDrawerContainer) {
    console.warn('Menu drawer container not found');
  }
  if (!menuDrawer) {
    console.warn('Menu drawer not found');
  }
  
  // Ensure ALL summaries (hamburger + categorie nel pannello) sono cliccabili
  if (menuDrawerContainer) {
    const allSummaries = menuDrawerContainer.querySelectorAll('summary');
    allSummaries.forEach(function(summary) {
      summary.style.pointerEvents = 'auto';
      summary.style.cursor = 'pointer';
      summary.setAttribute('tabindex', '0');
    });
  }
  
  // Close menu drawer when clicking outside (but not on summary/accordion)
  if (menuDrawer && menuDrawerContainer) {
    // Use event delegation to avoid interfering with native details behavior
    document.addEventListener('click', function(e) {
      // Non chiudere se il click è su un qualsiasi summary dentro il drawer (toggle accordion)
      const clickedSummary = e.target.closest ? e.target.closest('summary') : null;
      if (clickedSummary && menuDrawer && menuDrawer.contains(clickedSummary)) {
        return;
      }
      
      if (menuDrawerContainer.hasAttribute('open')) {
        // Close only if clicking outside the drawer
        if (!menuDrawer.contains(e.target)) {
          menuDrawerContainer.removeAttribute('open');
        }
      }
    }, true); // Use capture phase to handle before native behavior
    
    // Also close when clicking on overlay
    if (menuDrawerContainer) {
      menuDrawerContainer.addEventListener('click', function(e) {
        // If clicking directly on the container (overlay area), close
        if (e.target === menuDrawerContainer && menuDrawerContainer.hasAttribute('open')) {
          menuDrawerContainer.removeAttribute('open');
        }
      });
    }
    
    // Reset search when menu closes and handle body scroll
    const menuObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (menuDrawerContainer.hasAttribute('open')) {
            // Menu opened - prevent body scroll
            document.body.style.overflow = 'hidden';
          } else {
            // Menu closed - allow body scroll
            document.body.style.overflow = '';
            // Close all details
            if (menuDrawerMenu) {
              const allDetails = menuDrawerMenu.querySelectorAll('.menu-drawer__details');
              allDetails.forEach(d => d.removeAttribute('open'));
            }
          }
        }
      });
    });
    
    if (menuDrawerContainer) {
      menuObserver.observe(menuDrawerContainer, { attributes: true, attributeFilter: ['open'] });
    }
  }
  
  
  // Submenu slide panels functionality
  if (menuDrawerMenu) {
    const submenuTriggers = menuDrawerMenu.querySelectorAll('[data-submenu-trigger]');
    const submenuPanels = document.querySelectorAll('.menu-drawer__submenu-panel');
    const submenuBackButtons = document.querySelectorAll('[data-submenu-back]');
    
    // Open submenu panel
    submenuTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const panelId = this.getAttribute('data-submenu-trigger');
        const panel = document.getElementById(panelId);
        
        if (panel) {
          // Hide main menu
          menuDrawerMenu.style.transform = 'translateX(-100%)';
          // Show submenu panel
          panel.classList.add('active');
        }
      });
    });
    
    // Close submenu panel (back button)
    submenuBackButtons.forEach(backBtn => {
      backBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const panel = this.closest('.menu-drawer__submenu-panel');
        
        if (panel) {
          panel.classList.remove('active');
          // Show main menu
          menuDrawerMenu.style.transform = 'translateX(0)';
        }
      });
    });
    
    // Reset panels when menu closes
    if (menuDrawerContainer) {
      const resetObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (!menuDrawerContainer.hasAttribute('open')) {
              // Reset all panels
              submenuPanels.forEach(panel => {
                panel.classList.remove('active');
              });
              menuDrawerMenu.style.transform = 'translateX(0)';
            }
          }
        });
      });
      resetObserver.observe(menuDrawerContainer, { attributes: true, attributeFilter: ['open'] });
    }
  }
  
  // Handle search modal
  const searchModal = document.querySelector('.search-modal');
  const searchToggle = document.querySelector('[aria-label*="search"]');
  const searchClose = document.querySelector('.search-modal__close-button');
  const searchDetails = document.querySelector('.header__search details');
  
  // Open modal when details opens
  if (searchDetails) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (searchDetails.hasAttribute('open')) {
            if (searchModal) {
              searchModal.classList.add('active');
              document.body.style.overflow = 'hidden';
              const searchInput = searchModal.querySelector('input[type="search"]');
              if (searchInput) {
                setTimeout(() => searchInput.focus(), 100);
              }
            }
          } else {
            if (searchModal) {
              searchModal.classList.remove('active');
              document.body.style.overflow = '';
            }
          }
        }
      });
    });
    
    observer.observe(searchDetails, { attributes: true, attributeFilter: ['open'] });
  }
  
  if (searchToggle && searchModal) {
    searchToggle.addEventListener('click', function() {
      searchModal.classList.add('active');
      document.body.style.overflow = 'hidden';
      const searchInput = searchModal.querySelector('input[type="search"]');
      if (searchInput) {
        setTimeout(() => searchInput.focus(), 100);
      }
    });
  }
  
  if (searchClose) {
    searchClose.addEventListener('click', function() {
      if (searchModal) {
        searchModal.classList.remove('active');
        document.body.style.overflow = '';
      }
      if (searchDetails) {
        searchDetails.removeAttribute('open');
      }
    });
  }
  
  // Close modal on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchModal && searchModal.classList.contains('active')) {
      searchModal.classList.remove('active');
      document.body.style.overflow = '';
      if (searchDetails) {
        searchDetails.removeAttribute('open');
      }
    }
  });
  
  // Handle desktop dropdown menus - un solo menu aperto alla volta (evita "submenu Scarpe sotto tutte le voci")
  const megaMenus = document.querySelectorAll('.mega-menu');
  const headerWrapper = document.querySelector('.header-wrapper');
  
  function closeOtherMegaMenus(exceptElement) {
    megaMenus.forEach(function(menu) {
      if (menu !== exceptElement && menu.hasAttribute('open')) {
        menu.removeAttribute('open');
      }
    });
  }
  
  megaMenus.forEach(menu => {
    const summary = menu.querySelector('summary');
    const submenu = menu.querySelector('.header__submenu');
    
    // Quando si apre questo menu, chiudi tutti gli altri (fix: submenu Scarpe che appariva sotto Abbigliamento/Contatti)
    menu.addEventListener('toggle', function() {
      if (menu.hasAttribute('open')) {
        closeOtherMegaMenus(menu);
      }
    });
    
    if (summary && submenu) {
      // Close dropdown when clicking outside
      document.addEventListener('click', function(e) {
        if (!menu.contains(e.target) && menu.hasAttribute('open')) {
          menu.removeAttribute('open');
        }
        // Chiudi anche se click fuori dal submenu prodotti (il submenu è fuori dal details)
        var productsSubmenu = headerWrapper && headerWrapper.querySelector('.header__submenu--products');
        if (productsSubmenu && !productsSubmenu.contains(e.target) && !menu.contains(e.target) && menu.classList.contains('mega-menu--products') && menu.hasAttribute('open')) {
          menu.removeAttribute('open');
        }
      });
      
      // Prevent closing when clicking inside submenu
      submenu.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    } else if (summary && menu.classList.contains('mega-menu--products')) {
      // Submenu prodotti è fuori dal details: click outside chiude lo stesso
      document.addEventListener('click', function(e) {
        var productsSubmenu = headerWrapper && headerWrapper.querySelector('.header__submenu--products');
        var clickedInsideSubmenu = productsSubmenu && productsSubmenu.contains(e.target);
        if (!menu.contains(e.target) && !clickedInsideSubmenu && menu.hasAttribute('open')) {
          menu.removeAttribute('open');
        }
      });
      if (headerWrapper) {
        var productsSubmenu = headerWrapper.querySelector('.header__submenu--products');
        if (productsSubmenu) {
          productsSubmenu.addEventListener('click', function(e) {
            e.stopPropagation();
          });
        }
      }
    }
  });
  
  // Close modals on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      // Close mobile menu
      if (menuDrawerContainer && menuDrawerContainer.hasAttribute('open')) {
        menuDrawerContainer.removeAttribute('open');
      }
      // Close search modal
      if (searchModal) searchModal.classList.remove('active');
      // Close all mega menus
      megaMenus.forEach(menu => {
        if (menu.hasAttribute('open')) {
          menu.removeAttribute('open');
        }
      });
      // Close localization selector (desktop details)
      document.querySelectorAll('.localization-selector--desktop .localization-selector__details[open]').forEach((el) => {
        el.removeAttribute('open');
      });
    }
  });
  
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href.length > 1) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
  
  // Lazy load images
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    });
    
    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }
});

// Cart functionality
window.cartFunctions = {
  addToCart: function(variantId, quantity = 1) {
    const addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.errors) {
        console.error('Error adding to cart:', data.errors);
      } else {
        // Update cart count
        this.updateCartCount(data.item_count);
        // Show success message
        this.showCartNotification();
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  },
  
  updateCartCount: function(count) {
    const cartBubble = document.querySelector('.cart-count-bubble');
    if (cartBubble) {
      cartBubble.textContent = count;
      cartBubble.style.display = count > 0 ? 'block' : 'none';
    }
  },
  
  showCartNotification: function() {
    // Implement cart notification if needed
    console.log('Item added to cart');
  }
};

// Wishlist functionality
window.wishlistFunctions = {
  getWishlist: function() {
    try {
      const wishlist = localStorage.getItem('dike_wishlist');
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (e) {
      console.error('Error reading wishlist:', e);
      return [];
    }
  },
  
  saveWishlist: function(wishlist) {
    try {
      localStorage.setItem('dike_wishlist', JSON.stringify(wishlist));
      this.updateWishlistUI();
    } catch (e) {
      console.error('Error saving wishlist:', e);
    }
  },
  
  addToWishlist: function(productId, productHandle) {
    const wishlist = this.getWishlist();
    const productIdStr = String(productId);
    if (!wishlist.find(item => String(item.id) === productIdStr)) {
      wishlist.push({
        id: productIdStr,
        handle: productHandle || '',
        addedAt: new Date().toISOString()
      });
      this.saveWishlist(wishlist);
      return true;
    }
    return false;
  },
  
  removeFromWishlist: function(productId) {
    const wishlist = this.getWishlist();
    const productIdStr = String(productId);
    const filtered = wishlist.filter(item => String(item.id) !== productIdStr);
    this.saveWishlist(filtered);
    return filtered.length < wishlist.length;
  },
  
  isInWishlist: function(productId) {
    const wishlist = this.getWishlist();
    const productIdStr = String(productId);
    return wishlist.some(item => String(item.id) === productIdStr);
  },
  
  toggleWishlist: function(productId, productHandle) {
    const productIdStr = String(productId);
    if (this.isInWishlist(productIdStr)) {
      this.removeFromWishlist(productIdStr);
      return false;
    } else {
      this.addToWishlist(productIdStr, productHandle);
      return true;
    }
  },
  
  updateWishlistUI: function() {
    try {
      const wishlist = this.getWishlist();
      
      // Cerca solo i bottoni wishlist specifici
      const wishlistButtonSelectors = [
        '.collection-page__wishlist-button[data-product-id]',
        '.product-page__wishlist[data-product-id]',
        '.cart-page__item-wishlist[data-product-id]',
        '.cart-drawer__item-wishlist[data-product-id]'
      ];
      
      const allSelectors = wishlistButtonSelectors.join(', ');
      const wishlistButtons = document.querySelectorAll(allSelectors);
      
      wishlistButtons.forEach(button => {
        const productId = button.getAttribute('data-product-id');
        if (productId) {
          if (this.isInWishlist(productId)) {
            button.classList.add('active');
            button.setAttribute('aria-label', 'Rimuovi dai preferiti');
          } else {
            button.classList.remove('active');
            button.setAttribute('aria-label', 'Aggiungi ai preferiti');
          }
        }
      });
      
      // Update header wishlist icon and counter
      const wishlistIcon = document.getElementById('wishlist-icon');
      const wishlistCountBubble = document.getElementById('wishlist-count-bubble');
      const wishlistCount = document.getElementById('wishlist-count');
      
      if (wishlistIcon) {
        if (wishlist.length > 0) {
          wishlistIcon.classList.add('active');
        } else {
          wishlistIcon.classList.remove('active');
        }
      }
      
      // Update wishlist counter
      if (wishlistCountBubble && wishlistCount) {
        if (wishlist.length > 0) {
          wishlistCount.textContent = wishlist.length > 99 ? '99+' : wishlist.length;
          wishlistCountBubble.style.display = 'flex';
        } else {
          wishlistCountBubble.style.display = 'none';
        }
      }
    } catch (e) {
      console.error('Error updating wishlist UI:', e);
    }
  }
};

// Initialize wishlist on page load
function initializeWishlist() {
  // Update UI for existing wishlist items
  if (window.wishlistFunctions) {
    window.wishlistFunctions.updateWishlistUI();
  }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWishlist);
} else {
  // DOM già caricato
  initializeWishlist();
}

// Inizializza anche quando la pagina è completamente caricata
window.addEventListener('load', function() {
  if (window.wishlistFunctions) {
    window.wishlistFunctions.updateWishlistUI();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  
  // Function to handle wishlist button clicks
  function handleWishlistClick(e) {
    // Cerca il bottone wishlist - controlla se il target è il bottone stesso, l'SVG, o un elemento dentro
    let wishlistButton = e.target.closest('.collection-page__wishlist-button, .product-page__wishlist, .cart-page__item-wishlist, .cart-drawer__item-wishlist');
    
    // Se non trovato, cerca se il target è un SVG o path dentro un bottone wishlist
    if (!wishlistButton) {
      const svg = e.target.closest('svg.icon-wishlist, svg');
      if (svg) {
        wishlistButton = svg.closest('button[data-product-id]');
      }
    }
    
    // Se ancora non trovato, cerca direttamente un elemento con data-product-id che sia un bottone
    if (!wishlistButton && e.target.hasAttribute && e.target.hasAttribute('data-product-id')) {
      wishlistButton = e.target;
    }
    
    // Verifica che sia un bottone wishlist valido
    if (wishlistButton && wishlistButton.tagName === 'BUTTON' && (
      wishlistButton.classList.contains('collection-page__wishlist-button') ||
      wishlistButton.classList.contains('product-page__wishlist') ||
      wishlistButton.classList.contains('cart-page__item-wishlist') ||
      wishlistButton.classList.contains('cart-drawer__item-wishlist')
    )) {
      e.preventDefault();
      e.stopPropagation();
      
      const productId = wishlistButton.getAttribute('data-product-id');
      const productHandle = wishlistButton.getAttribute('data-product-handle');
      
      if (productId && window.wishlistFunctions) {
        const wasInWishlist = window.wishlistFunctions.isInWishlist(productId);
        const isAdded = window.wishlistFunctions.toggleWishlist(productId, productHandle);
        
        // Visual feedback immediato sul bottone cliccato
        if (isAdded) {
          wishlistButton.classList.add('active');
          wishlistButton.setAttribute('aria-label', 'Rimuovi dai preferiti');
          
          // Mostra toast di successo
          if (window.showToast) {
            window.showToast('Prodotto aggiunto ai preferiti', 'success');
          }
        } else {
          wishlistButton.classList.remove('active');
          wishlistButton.setAttribute('aria-label', 'Aggiungi ai preferiti');
          
          // Mostra toast di rimozione
          if (window.showToast) {
            window.showToast('Prodotto rimosso dai preferiti', 'info');
          }
        }
        
        // Aggiorna l'UI di tutti i bottoni wishlist sulla pagina (anche quelli dinamici)
        setTimeout(() => {
          if (window.wishlistFunctions) {
            window.wishlistFunctions.updateWishlistUI();
          }
        }, 100);
      } else {
        console.warn('Wishlist button clicked but productId or wishlistFunctions not available', {
          productId,
          hasWishlistFunctions: !!window.wishlistFunctions
        });
      }
    }
  }
  
  // Add event listeners to wishlist buttons - usa capture per catturare prima che altri handler
  document.addEventListener('click', handleWishlistClick, true);
  
  // Anche per i bottoni che vengono aggiunti dinamicamente
  // Usa MutationObserver per nuovi bottoni aggiunti al DOM
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Se è un bottone wishlist o contiene bottoni wishlist
            if (node.matches && (
              node.matches('.collection-page__wishlist-button, .product-page__wishlist, .cart-page__item-wishlist, .cart-drawer__item-wishlist') ||
              node.querySelector('.collection-page__wishlist-button, .product-page__wishlist, .cart-page__item-wishlist, .cart-drawer__item-wishlist')
            )) {
              // Aggiorna l'UI per i nuovi bottoni
              if (window.wishlistFunctions) {
                window.wishlistFunctions.updateWishlistUI();
              }
            }
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});

